export const USER_ROLES = {
  MASTER_ADMIN: 'Master Admin',
  Admin: 'Admin',
  User: 'User',
  Employee: 'Employee'
} as const

/** Normalize API role labels (spacing, case, enum-style) for comparisons. */
function normalizeRoleLabel(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
}

/**
 * True when the user has the Master Admin role (by display name or common API variants).
 * Also use {@link canActAsMasterAdmin} when the profile omits `role` but admin-panel permission is set.
 */
export function isMasterAdminRole(role: { name?: string }): boolean {
  const raw = role?.name

  if (raw == null || String(raw).trim() === '') {
    return false
  }

  const n = normalizeRoleLabel(String(raw))
  const expected = normalizeRoleLabel(USER_ROLES.MASTER_ADMIN)

  return n === expected || n === 'masteradmin'
}

/** Master Admin UI: role name match, or admin-panel access (same gate as /admin routes). */
export function canActAsMasterAdmin(
  role: { name?: string },
  permissions: { can_view_admin_panel?: boolean } | null | undefined
): boolean {
  return (
    isMasterAdminRole(role) ||
    permissions?.can_view_admin_panel === true
  )
}
